import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';
import * as _ from "lodash";

//validators
import { dropDownValidator } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as util from '../../util/index'

//components


//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';
import { CompletionNumberType, RequestTotalsByTypeAndStatus } from '../../entities/index';

@Component({
    selector: 'my-request-invoice-numbers',
    templateUrl: './RequestInvoiceNumbers.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => RequestInvoiceNumbersComponent) }]
})
export class RequestInvoiceNumbersComponent extends BaseControlGroupComponent {

    request: ent.Request;
    lineItems: ent.RequestInvoiceNumber[] = [];

    setDates() { }

    setRequestInfo(request: ent.Request) {
        this.request = request;
    }



    constructor(fb: FormBuilder) {
        super();
    }

    ngOnInit(): void {

    }

    onAddLineItemClick(event: any) {
        if (!this.lineItems) { this.lineItems = [] }
        var newLineItem: ent.RequestInvoiceNumber = { Number: "" };

        this.lineItems = [...this.lineItems, newLineItem];
    }

    onDeleteClick(event: any, lineItem: ent.RequestInvoiceNumber) {
        this.lineItems = _.remove(this.lineItems, x => x.Number !== lineItem.Number);
    }


}